module.exports = __webpack_public_path__ + "static/money-min-62738a0cfe90a39ea8bff12bcefa2b18.jpg";